import { AuthLayout } from '../../src/layout/AuthLayout';
export default function Authenticated() {
  return <AuthLayout authenticate />;
}
